<template>
  <div class="wrapper">
    <div class="login">
      <div class="se-logo" />
      <div class="content">
        <div class="dij-logo">
          <div class="abbreviation">DIJ</div>
          <div class="name">
            <div class="name-top">Digital</div>
            <div class="name-bottom">Inspection Jacket</div>
          </div>
        </div>
        <div class="loading">
          <div class="loading-icon"></div>
          <div class="loading-text">Logging in...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleRedirect, acquireToken } from '../../services/auth';
import { SEND_WEBSOCKET_MESSAGE } from '../../store/websocket/actions/actionTypes';
import onlineService from '../../services/onlineService';

export default {
  name: 'Callback',
  async created() {
    try {
      console.log('Handling callback');
      console.log('Before clearing, sessionStorage:', sessionStorage);
      sessionStorage.removeItem('editor_page');
      sessionStorage.removeItem('report_page');
      sessionStorage.removeItem('inspector_page');
      sessionStorage.removeItem('publisher_page');

      this.$cookies.remove('editor_page_lastKey');
      this.$cookies.remove('report_page_lastKey');
      this.$cookies.remove('publisher_page_lastKey');
      this.$cookies.remove('inspector_page_lastKey');
      console.log('After clearing, sessionStorage:', sessionStorage);

      console.log('Handling redirect ');
      await handleRedirect();
      console.log('Acquiring token');
      const token = await acquireToken();
      if (!token) {
        return;
      }

      if (await onlineService.canConnectRealtime()) {
        setTimeout(() => {
          console.log('Registering token with WebSocket');
          this.$store.dispatch(SEND_WEBSOCKET_MESSAGE, {
            action: 'registerToken',
            data: token,
          });
        }, 0);
      }

      let isNewUser = false;

      console.log('Fetching user profile');
      await this.$store
        .dispatch('getCurrentUserProfile')
        .then(() => {
          console.log('User profile fetched successfully');
          const { currentUser } = this.$store.state;
          isNewUser = currentUser.isPendingApproval;
        })
        .catch(() => {
          console.log('Failed to fetch user profile');
          isNewUser = true;
          return this.$store.dispatch('createUserSelf');
        });

      // await this.$store.dispatch('login'); // handled inside getCurrentUserProfile

      const redirectPath = localStorage.getItem('path');
      if (isNewUser) {
        console.log('Redirecting to new user welcome page');
        this.$router.replace({ path: '/new-user-welcome-page' });
      } else if (redirectPath) {
        console.log('Redirecting to stored path:', redirectPath);
        localStorage.removeItem('path');
        this.$router.replace({ path: redirectPath });
      } else {
        console.log('Redirecting to dashboard');
        this.$router.replace({ path: '/view/dashboard' });
      }
    } catch (e) {
      console.error('Callback handling failed', e);
      // this.$router.replace({ path: '/login' });
      console.log('Error', '/view/dashboard');
      this.$router.push({ path: '/view/dashboard' });
    }
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login {
  width: 100%;
  background-color: white;
  margin: 20px;
  padding: 20px;
  box-shadow: 0px 0px 5px grey;
}

.se-logo {
  width: 100px;
  height: 50px;
  background-image: url('/img/se_logo_color_rgb.svg');
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 50px;
}

.content {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.dij-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgb(100, 30, 140);

  .abbreviation {
    font-size: 96px;
    border-right: 2px solid rgb(100, 30, 140);
    line-height: 62px;
    height: 82px;
    padding-right: 10px;
  }

  .name {
    font-size: 36px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
  }

  .name-top {
    height: 48px;
  }

  .name-bottom {
    height: 48px;
    margin-bottom: 5px;
  }
}

.loading {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-icon {
  width: 100px;
  height: 100px;
  animation: spin 750ms infinite linear;
  border: 2px solid #b9b9b9;
  border-radius: 100px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.loading-text {
  position: absolute;
  margin-top: 0;
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
